/* YATS — Billion "one child's journey" scroll scene.
   DOM image crossfade + a gentle Ken Burns + kinetic word reveals drive the story.
   A Three.js layer of drifting light-motes sits over the photos, its colour and
   intensity scrubbed by scroll. The motes are deliberately faint: the frames are
   photoreal generated brand/lifestyle art and the effects must stay under them,
   not on top. (The drifting "imagine / soar / discover" word sprites were removed
   — they read as decoration pasted over the photography.)
   Degrades gracefully: no-WebGL / reduced-motion keeps the image + text scrub.
   Swap the photos by overwriting theme/assets/yats-journey-1..5.jpg (beat 5 also has a
   tall phone crop, yats-journey-5-m.jpg, which must be rebuilt from the new frame). */
(function () {
  'use strict';
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function init() {
    var sec = document.querySelector('[data-bil-journey]'); if (!sec) return;
    var imgs = [].slice.call(sec.querySelectorAll('[data-bilj-img]'));
    var panels = [].slice.call(sec.querySelectorAll('[data-bilj-panel]'));
    var dots = [].slice.call(sec.querySelectorAll('[data-bilj-dot]'));
    var heads = [].slice.call(sec.querySelectorAll('[data-bilj-headline]'));
    var hint = sec.querySelector('[data-bilj-hint]');
    var canvas = sec.querySelector('[data-bilj-canvas]');
    var stage = sec.querySelector('[data-bilj-stage]');
    var pin = sec.querySelector('.bilj-pin');
    var N = imgs.length; if (!N) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* wrap each headline's words for staggered reveal */
    heads.forEach(function (h) {
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var sp = document.createElement('span');
        sp.className = 'bilj-word'; sp.textContent = w;
        sp.style.transitionDelay = (0.12 + i * 0.05) + 's';
        h.appendChild(sp); h.appendChild(document.createTextNode(' '));
      });
    });

    var curBeat = -1;
    function setActive(beat) {
      if (beat === curBeat) return; curBeat = beat;
      panels.forEach(function (p, i) { p.classList.toggle('is-on', i === beat); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === beat); });
    }

    var prog = 0;
    function updateScroll() {
      var r = sec.getBoundingClientRect();
      /* The stage is pinned SHORTER than the viewport and offset below the sticky
         header, so the scrub has to measure the pin itself — using innerHeight here
         desynced the beats from the photos as soon as the pin stopped being 100vh. */
      var pinH = pin ? pin.offsetHeight : window.innerHeight;
      var stick = pin ? (parseFloat(window.getComputedStyle(pin).top) || 0) : 0;
      var travel = sec.offsetHeight - pinH;
      var p = travel > 0 ? clamp((stick - r.top) / travel, 0, 1) : 0;
      prog = p;
      var band = 1 / (N - 1);
      for (var i = 0; i < N; i++) {
        var c = i * band;
        var o = clamp(1 - Math.abs(p - c) / band, 0, 1);
        imgs[i].style.opacity = o.toFixed(3);
        if (!reduce) {
          var local = clamp((p - c) / band + 0.5, 0, 1);
          imgs[i].style.transform = 'scale(' + (1.02 + local * 0.05).toFixed(3) + ')';
        }
      }
      setActive(clamp(Math.round(p * (N - 1)), 0, N - 1));
      if (hint) hint.style.opacity = p > 0.03 ? '0' : '1';
    }

    /* ---------- Three.js particle layer (enhancement only) ---------- */
    var running = false, raf = 0, three = null;
    if (!reduce && window.THREE && canvas) {
      try { three = buildThree(); } catch (e) { three = null; }
    }
    if (!three && canvas) canvas.style.display = 'none';

    function buildThree() {
      var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(55, 1, 0.1, 100);
      camera.position.set(0, 0, 14);

      /* soft round sprite for motes */
      var cv = document.createElement('canvas'); cv.width = cv.height = 64;
      var c2 = cv.getContext('2d');
      var g = c2.createRadialGradient(32, 32, 0, 32, 32, 32);
      g.addColorStop(0, 'rgba(255,255,255,1)');
      g.addColorStop(0.4, 'rgba(255,255,255,0.55)');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      c2.fillStyle = g; c2.fillRect(0, 0, 64, 64);
      var motTex = new THREE.CanvasTexture(cv);

      var M = 80;
      var geo = new THREE.BufferGeometry();
      var pos = new Float32Array(M * 3), spd = new Float32Array(M);
      for (var i = 0; i < M; i++) {
        pos[i * 3] = (Math.random() - 0.5) * 34;
        pos[i * 3 + 1] = (Math.random() - 0.5) * 24;
        pos[i * 3 + 2] = (Math.random() - 0.5) * 8;
        spd[i] = 0.4 + Math.random() * 1.3;
      }
      geo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
      var mat = new THREE.PointsMaterial({ size: 0.42, map: motTex, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, opacity: 0.3 });
      mat.color = new THREE.Color(0xffd86b);
      var motes = new THREE.Points(geo, mat); scene.add(motes);

      /* per-beat tints: cool → gold → violet → warm → bright */
      var palette = [new THREE.Color(0x6da0ff), new THREE.Color(0xffb43c), new THREE.Color(0xa86bff), new THREE.Color(0xffc070), new THREE.Color(0xffe6a0)];
      var lastT = performance.now();

      function frame(now) {
        var dt = Math.min(0.05, (now - lastT) / 1000); lastT = now;
        var arr = geo.attributes.position.array;
        for (var i = 0; i < M; i++) {
          arr[i * 3 + 1] += dt * spd[i] * (0.6 + prog * 0.9);
          if (arr[i * 3 + 1] > 13) { arr[i * 3 + 1] = -13; arr[i * 3] = (Math.random() - 0.5) * 34; }
        }
        geo.attributes.position.needsUpdate = true;

        var fp = prog * (N - 1), bi = clamp(Math.floor(fp), 0, N - 2), bf = fp - bi;
        var col = palette[bi].clone().lerp(palette[bi + 1], bf);
        mat.color.copy(col);
        mat.opacity = 0.13 + prog * 0.13;

        camera.position.x = Math.sin(now / 6000) * 0.6;
        camera.lookAt(0, 0, 0);
        renderer.render(scene, camera);
        if (running) raf = requestAnimationFrame(frame);
      }
      function resize() {
        var w = stage.clientWidth, h = stage.clientHeight; if (!w || !h) return;
        renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix();
      }
      return { frame: frame, resize: resize };
    }

    function start() { if (three && !running) { running = true; raf = requestAnimationFrame(three.frame); } }
    function stop() { running = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } }

    if (three) {
      three.resize();
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { rootMargin: '10% 0px' }).observe(sec);
      window.addEventListener('resize', function () { three.resize(); });
    }

    window.addEventListener('resize', updateScroll);
    document.addEventListener('scroll', updateScroll, { passive: true, capture: true });
    updateScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
